import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {attachedPaginatedPayload} from '../../../util'
import { getReports,mediaPrivacyRequest } from '../../../api/endpoints/reports'


interface ChangeMediaPrivacyPayload {
  data: any; 
  success: boolean;
  code: number;
  mediaId: number; 
}

interface reportsState {
  reports: Array<any>
  pagination: any
  filter: {
    query: string
    userType: string
  }
  status: string
  error: string | null
}

interface ChangeMediaPrivacyParams {
  mediaId: number;
  privacy: number;
}

const initialState: reportsState = {
  reports: [],
  pagination: {},
  filter: {
    query: '',
    userType: '',
  },
  status: 'idle',
  error: null,
}

export const getAllReportsAction = createAsyncThunk('get/all-reports', async (params: any) => {
  try {
    const res: any = await getReports(params)
    const {data, success} = res.data
    return {
      data,
      success,
      code: 200,
    }
  } catch (error) {
    return error
  }
})

export const changeMediaPrivacy = createAsyncThunk(
  'get/change-privacy',
  async ({ mediaId, privacy }: ChangeMediaPrivacyParams) => {
    try {
      const res: any = await mediaPrivacyRequest({ mediaId, privacy });
      const { data, success } = res.data;

      return {
        data,
        success,
        code: 200,
        mediaId,
      };
    } catch (error) {
      throw error; 
    }
  }
);



const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    addReportsMediaToState: (state, action) => {
      const {data} = action.payload
      const media = data.media
      const pagination = attachedPaginatedPayload(data)
      state.pagination = pagination
      state.reports = [...state.reports, ...media]
    },
    aggregateFilter: (state: any, {payload}: PayloadAction<any>) => {
      const {key, value} = payload
      state.filter[key] = value
    },
    resetFilters: (state, {payload}: {payload?: any}) => {
      state.filter = initialState.filter
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllReportsAction.pending, (state, action) => {
      state.status = 'loading'
    })
    builder.addCase(getAllReportsAction.fulfilled, (state, action: any) => {
      state.status = 'success'
      const filteredReports = action.payload.data.mediaReports.filter(
        (report:any) => report.media !== null && report.media !== undefined
      );
      state.reports = filteredReports
      state.pagination = attachedPaginatedPayload(action.payload.data)
    })
    builder.addCase(getAllReportsAction.rejected, (state, action) => {
      state.status = 'failed'
    })

    builder.addCase(changeMediaPrivacy.pending, (state, action) => {
      
    })
   builder.addCase(changeMediaPrivacy.fulfilled, (state, action) => {
      const { mediaId, success } = action.payload as ChangeMediaPrivacyPayload;
      if (success) {
        const report = state.reports.find(report => report.mediaId === mediaId);
        if (report) {
          report.media.isAdminPrivate = report.media.isAdminPrivate === 1 ? 0 : 1;
        }
      }
    });
    builder.addCase(changeMediaPrivacy.rejected, (state, action) => {
    })

  },
})

export const {addReportsMediaToState, aggregateFilter, resetFilters} = reportsSlice.actions

export const reportsSelector = (state: any) => state.reports.reports
export const reportsMediaPaginationSelector = (state: any) => state.reports.pagination
export const reportsMediaStatusSelector = (state: any) => state.reports.status
export const reportsMediaFilterSelector = (state: any) => state.reports.filter
export const reportsErrorSelector = (state: any) => state.reports.error

export default reportsSlice.reducer